export default __webpack_public_path__ + "static/media/howToSend.bbb156ad.png";